// src/lib/data-access/global-search.types.ts

import {ICycle, MinimalUserModel, UserGroup} from '@core/api/data-access';
import {CycleQueryBuilder} from '@cycles/data-access';
import {UserGroupsQueryBuilder, UsersQueryBuilder} from '@data-users';

/** ------------------------------- Global Search Category ------------------------------- */
export enum GlobalSearchCategory {
	CYCLE = 'CYCLE',
	USER = 'USER',
	USER_GROUP = 'USER_GROUP',
}

/** ------------------------------- Search Result By Category ------------------------------- */
export type SearchResultByCategory = {
	[GlobalSearchCategory.CYCLE]: ICycle;
	[GlobalSearchCategory.USER]: MinimalUserModel;
	[GlobalSearchCategory.USER_GROUP]: UserGroup;
};
export type SearchResultItem<Category extends GlobalSearchCategory = GlobalSearchCategory> = SearchResultByCategory[Category];

/** ------------------------------- Builder Class By Category ------------------------------- */
export type BuilderByCategory = {
	[GlobalSearchCategory.CYCLE]: typeof CycleQueryBuilder;
	[GlobalSearchCategory.USER]: typeof UsersQueryBuilder;
	[GlobalSearchCategory.USER_GROUP]: typeof UserGroupsQueryBuilder;
};

export const BuilderByCategory = {
	[GlobalSearchCategory.CYCLE]: CycleQueryBuilder,
	[GlobalSearchCategory.USER]: UsersQueryBuilder,
	[GlobalSearchCategory.USER_GROUP]: UserGroupsQueryBuilder,
} as const;

// טיפוסים של מופעים של הבנאים (instances)
export type BuilderByCategoryInstance<C extends GlobalSearchCategory = GlobalSearchCategory> = C extends GlobalSearchCategory.CYCLE
	? CycleQueryBuilder
	: C extends GlobalSearchCategory.USER
		? UsersQueryBuilder
		: C extends GlobalSearchCategory.USER_GROUP
			? UserGroupsQueryBuilder
			: never;

/** ------------------------------- Paged Result ------------------------------- */
export type PagedResult<T extends SearchResultItem> = {
	items: T[];
	total?: number;
	page?: number;
};

/** ------------------------------- Filter Types ------------------------------- */
export enum GlobalSearchFilterType {
	// Cycle Filters
	Status = 'Status', // יש לשקול לשנות ל-CycleType אם זה מייצג את הרשימות מה-Backend
	UpdateDateRange = 'UpdateDateRange', // שונה מ-DateRange
	CreateDateRange = 'CreateDateRange', // חדש
	Owner = 'Owner',

	// User Filters
	IncludeInactive = 'IncludeInactive', // שונה מ-Active
	IncludeTemporary = 'IncludeTemporary', // חדש
	// SignUpDateRange הוסר

	// UserGroup Filters
	GroupName = 'GroupName',
	MemberCount = 'MemberCount',
	LockedStatus = 'LockedStatus', // חדש
	EnabledStatus = 'EnabledStatus', // חדש
}

export interface IFilterUpdateResult<T> {
	normalizedValue: T | undefined; // הערך המנורמל שיישמר בסטייט
	requiresSearch: boolean; // האם השינוי מחייב חיפוש חדש
}
